import React, { useContext } from 'react';
import { Button, Row, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../main/components/Modal';
import { ElevatedPrivilegesSignupLinks } from '../ElevatedPrivilegesSignup';
import GlobalContext from '../../../main/utils/GlobalContext';

export const ModalEducatorInvites = ({
  visible = false,
  establishmentId,
  onClose,
}) => {
  const { locales } = useContext(GlobalContext);
  const { elevatedSignupLinks } = useSelector((state) => state);
  const {
    elevatedSignupLinks: {
      addEstablishmentSignupLink,
      deleteEstablishmentSignupLink,
    },
  } = useDispatch();

  const handleAddSignupCallback = (role) => {
    addEstablishmentSignupLink({
      establishmentId,
      role,
    });
  };

  const handleDeleteSignupCallback = (id) => {
    deleteEstablishmentSignupLink({
      id,
      establishmentId,
    });
  };

  return (
    <>
      {visible && (
        <Modal
          onBlackscreenClick={onClose}
          className="sm"
          title={locales.admin.manageElevatedPrivilegeInviteLinks}
          onClose={onClose}
          isOpen
        >
          <Row>
            <ElevatedPrivilegesSignupLinks
              addSignupCallback={handleAddSignupCallback}
              deleteSignupCallback={handleDeleteSignupCallback}
              elevatedSignupLinks={elevatedSignupLinks.data}
            />
          </Row>
          <div className="flex align-right mt-40">
            <Space>
              <Button onClick={onClose}>{locales.admin.close}</Button>
            </Space>
          </div>
        </Modal>
      )}
    </>
  );
};
